import { FormulaButton } from '../common/FormulaButton'

export const MobileFormulaPaletteButton = FormulaButton
